import { msg } from '@lingui/core/macro';
import { IPresets } from 'modules/template-editor/domain/consts/form/presets';

export type TemplatePresetsNameList = 'create' | 'edit' | 'duplicate' | 'copy' | 'delete';

export const templatePresets: Record<TemplatePresetsNameList, IPresets> = {
  create: {
    header: msg`Новый шаблон`,
    submitButton: msg`Создать`,
  },
  edit: {
    header: msg`Редактирование шаблона`,
    submitButton: msg`Сохранить`,
  },
  duplicate: {
    header: msg`Дублирование шаблона`,
    submitButton: msg`Создать`,
  },
  copy: {
    header: msg`Копирование шаблона`,
    submitButton: msg`Скопировать`,
  },
  delete: {
    header: msg`Удаление шаблона`,
    submitButton: msg`Удалить`,
  },
};
